import React, { Component } from 'react';
// import GoogleMapReact from 'google-map-react';

// const AnyReactComponent = ({ text }) => <div>{text}</div>;

class SimpleMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data
    }
  }

  static defaultProps = {
    center: {
      lat: 59.95,
      lng: 30.33
    },
    zoom: 11
  };

  render() {
    return (
      // Important! Always set the container height explicitly
      <div id="where" style={{
        padding: '5em',
        height: 'auto',
        width: '100%',
        display: "flex",
        flexDirection:"column",
        justifyContent: 'center',
        alignItems:"center",
        backgroundColor:"#f0f0f0"
      }}>
        
        <strong style={{fontSize:"20"}}> {this.props.data ? this.props.data.metro : "loading"} </strong>
        <strong style={{fontSize:"20"}}> {this.props.data ? this.props.data.buses : "loading"}  </strong>
        
        {/* <div className="mapouter"> */}
          <div className="map-iframe-container">
            <iframe
              title="map"
              // className="map-iframe"
              width="350"
              height="400"
              // id="gmap_canvas"
              src="https://maps.google.com/maps?q=Verdum%2055-57&t=&z=17&ie=UTF8&iwloc=&output=embed"
              frameborder="0"
              // scrolling="no"
              // marginheight="0"
              // marginwidth="0"
              style={{border:0}}
              allowfullscreen
            ></iframe>
          </div>
        {/* </div>  */}
        
      </div>
    );
  }
}

export default SimpleMap;